<!--
 * @Author: mazhigang
 * @Date: 2023-07-01 19:16:24
 * @LastEditors: mazhigang
 * @LastEditTime: 2023-07-14 16:40:29
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>系统管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageTabAdd">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <el-page-header
              @back="goBack"
              :content="editId == '' ? '新增角色' : '编辑角色'"
            >
            </el-page-header>
          </div>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item label="角色名称" prop="name">
              <el-input
                v-model="ruleForm.name"
                placeholder="请输入角色名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="角色描述" prop="describe">
              <el-input
                v-model="ruleForm.describe"
                placeholder="请输入角色描述"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="close()">取消</el-button>
              <el-button
                @click="submitForm('ruleForm')"
                class="btn"
                style="margin-right: auto"
                >保存</el-button
              >
            </el-form-item>
          </el-form>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.systemData(),
      ruleForm: {
        describe: "",
        name: "",
      },
      rules: {
        describe: [{ required: true, message: "必填项", trigger: "blur" }],
        name: [{ required: true, message: "必填项", trigger: "blur" }],
      },
      editId: "",
    };
  },
  created: function () {
    if (this.$route.query.id) {
      this.editId = this.$route.query.id;
      this.getDetail();
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {
            name: this.ruleForm.name,
            roleDesc: this.ruleForm.describe,
          };
          if (this.editId == "") {
            this.$axios
              .post(`/admapi/sys/roles/add`, param)
              .then(({ data }) => {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.$router.go(-1);
              })
              .catch()
              .finally();
          } else {
            this.$axios
              .post(`/admapi/sys/roles/update/${this.editId}`, param)
              .then(({ data }) => {
                this.$message({
                  message: "编辑成功",
                  type: "success",
                });
                this.$router.go(-1);
              })
              .catch()
              .finally();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleRemove(file) {
      console.log(file);
    },
    handleDownload(file) {
      console.log(file);
    },
    goBack() {
      this.$router.go(-1);
    },
    close() {
      this.$router.go(-1);
    },
    statusChange() {
      if (this.ruleForm.role.length > 1) {
        this.ruleForm.role.splice(0, 1);
      }
    },
    getDetail() {
      this.$axios
        .post(`/admapi/sys/roles/get/${this.editId}`)
        .then(({ data }) => {
          this.ruleForm.name = data.name;
          this.ruleForm.describe = data.roleDesc;
        })
        .catch()
        .finally();
    },
  },
};
</script>
<style scoped>
.demo-ruleForm {
  width: 650px;
}
</style>
